import BaseService from './base';
import request from '@/utils/request';

export interface MarkViewModel {
  id?: number;
  name?: string;
  mapID?: number;
  address?: string;
  oldAddress?: string;
  introduce?: string;
  lng?: number;
  lat?: number;
  videoCount?: number;
  photoCount?: number;
  otherCount?: number;
  attachment?: string;
}

export class MarkService extends BaseService<MarkViewModel> {
  protected serviceApi: string = 'Mark';

  get NewModel(): MarkViewModel {
    return {
      id: 0,
      name: '',
      address: '',
      videoCount: 0,
      photoCount: 0,
      otherCount: 0,
      lng: 0,
      lat: 0,
    };
  }

  public GetByMapID(id: number) {
    return request({
      url: this.serviceApi + '/GetByMapID/' + id.toString(),
      method: 'get',
    });
  }

  // public async Create(val: MarkViewModel) {
  //   return request({
  //     url: '/Mark/Create',
  //     method: 'post',
  //     data: val,
  //   });
  // }
  // public Search(val: MarkViewModel, pageIndex: number) {
  //   return request({
  //     url: '/Mark/Search/' + pageIndex.toString(),
  //     method: 'post',
  //     data: val,
  //   });
  // }
  // public GetById(id: number) {
  //   return request({
  //     url: '/Mark/GetByID/' + id.toString(),
  //     method: 'get',
  //   });
  // }
  // public Update(val: MarkViewModel) {
  //   return request({
  //     url: '/Mark/Update',
  //     method: 'put',
  //     data: val,
  //   });
  // }
  // public Delete(id: number) {
  //   return request({
  //     url: '/Mark/Delete/' + id.toString(),
  //     method: 'delete',
  //   });
  // }
}
